module.exports = __webpack_public_path__ + "static/media/deleteIcon.5bf0cc9d.svg";